// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { TaskLogOutput } from 'thehive-sdk';
import { ResultCard } from '@Organisms/Search/SearchResultCard/ResultCard';
import { extractData } from './extractData';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

import './LogResultCard.scss';
import RouteBuilder from '@Services/RouteBuilder';

interface LogResultCardProps {
    data?: TaskLogOutput;
}

export const LogResultCard = ({ data }: LogResultCardProps): ReactElement => {
    const i = useLocalMessage();

    const { _createdAt = 0, _createdBy = '', message = '', extraData } = data || {};
    const caseId = extraData?.task?.case?._id;
    const taskId = extraData?.task?._id;

    const title = i('search.results.message-by', { user: _createdBy });
    const caseTitle = `#${extraData?.task?.case?.number} ${extraData?.task?.case?.title}`;

    return (
        <ResultCard
            data={{
                '#computeTitle': {
                    title,
                    icon: <ICONS.TaskLogIcon />,
                    path: RouteBuilder.compute('cases.task', { caseId, taskId }),
                },
                '#computeDate': {
                    date: _createdAt,
                    _createdBy,
                },
                '#computeDescription': message,
                '#computeCaseTitle': {
                    title: caseTitle,
                    icon: <ICONS.CaseIcon />,
                    path: RouteBuilder.compute('cases.details', { caseId }),
                },
            }}
            extract={extractData({ locale: i })}
        />
    );
};
